// ** Reducers Imports
// import navbar from './navbar'
import navigationStep from "./navigationStep";
import auth from './authentication'
import layout from './layout';

const rootReducer = {
  auth,
  //navbar,
  layout,
  navigationStep
}

export default rootReducer
